const isUpper = (value: string): boolean =>
  value !== value.toLowerCase() && value === value.toUpperCase();

// Mirrors the backend's camelize (pyhumps): only a separator starts a new word.
// lodash camelCase also splits digits from letters ("8000no" → "8000No"), which
// misses the row property and decamelizes to a field key that doesn't exist.
export const camelizeFieldKey = (fieldKey: string): string => {
  if (isUpper(fieldKey) || /^\d+$/.test(fieldKey)) return fieldKey;
  const key = isUpper(fieldKey.slice(0, 2))
    ? fieldKey
    : fieldKey.charAt(0).toLowerCase() + fieldKey.slice(1);
  return key.replace(/(?<=[^-_])[-_]+([^-_])/g, (_, char: string) =>
    char.toUpperCase()
  );
};
